import SidebarMenu from './SidebarMenu.vue'
export {SidebarMenu}
export default SidebarMenu

